import { useEffect } from 'react';
import { showToast } from '../../components/Toast/Toast';
import { ToastTypes } from '../../components/Toast/Toast.types';
import { genericErrorShowToastOptions } from '../useGenericErrorMessage/useGenericErrorMessage';

export const useFetchErrorToast = (
  errors: { isError: boolean; label: string; id: string; ignoredErrors?: string[]; error?: any }[]
) => {
  const error = errors.find((error) => error.isError);
  useEffect(() => {
    const _ignoredErrors = error?.ignoredErrors
      ? [...error?.ignoredErrors, 'apiGatewayTimeout']
      : ['apiGatewayTimeout'];
    if (error && !_ignoredErrors?.includes(error.error?.message as string))
      showToast({
        ...genericErrorShowToastOptions,
        label: error.label,
        id: error.id,
        toastType: ToastTypes.Error,
      });
  }, [error]);
};
